export function executeWhenDOMIsReady(fn: () => Promise<void> | void): void {
  if (document.readyState != 'loading') {
    void fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
